import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable } from "rxjs";
import { Field } from "src/app/common/common.model";
import { NyBaseClass } from "src/app/common/ny/ny-base";
import { NotificationService } from "src/app/services/notification.service";
import { TilgangService } from "src/app/services/tilgang.service";
import { Server, ServereService } from "../server.service";

@Component({
  selector: "app-server-ny",
  templateUrl: "../../common/ny/ny-base.html"
})
export class ServereNyComponent extends NyBaseClass<Server> {


  constructor(
    private service: ServereService,
    tilgangService: TilgangService,
    route: ActivatedRoute,
    router: Router,
    notificationService: NotificationService
  ) { super(route, router, tilgangService, notificationService); }

  create(model: Server): Observable<Server> {
    return this.service.post(model);
  }
  getCreateFields(): Observable<Field[]> {
    return this.service.getCreateFields();
  }
  getTitle(): string {
    return "Servere";
  }
  getHeadline(): string {
    return "Opprett ny server";
  }

  getIdFromDataType(model: Server): number {
    return model.serverId;
  }

}
